import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionStorageService } from '../../../services/session-storage.service';
import { PostTradeService } from '../../post-trade.service';
import { ptUtilityApps } from '../../../lib/utility-apps';
import { UtilityAppsService } from '../../../shared-components/utility-apps/utility-apps.service';

import { RbGridComponent } from '../../../shared-components/rb-grid/rb-grid.component';
import { AmlMonitorDetailComponent } from '../aml-monitor-detail/aml-monitor-detail.component';
import { BreadcrumbComponent } from '../../../breadcrumb/breadcrumb.component';
@Component({
  selector: 'app-aml-monitor',
  templateUrl: './aml-monitor.component.html',
  styleUrls: ['./aml-monitor.component.scss'],
  imports: [RbGridComponent, AmlMonitorDetailComponent, BreadcrumbComponent],
})
export class AmlMonitorComponent implements OnInit, OnDestroy {
  ptSvc = inject(PostTradeService);
  private activatedRoute = inject(ActivatedRoute);
  private ss = inject(SessionStorageService);
  private route = inject(Router);
  private uas = inject(UtilityAppsService);

  rights = [];
  unsubscribe: Subject<any> = new Subject();
  amlId = '';
  gridConfig = {
    title: 'Anti-Money Laundering Monitor',
    gridName: 'AmlMonitorGrid',
    showGridFilters: true,
    showFilterManager: true,
    manualSearch: true,
    searchButtonText: 'Update Search',
    showBulkActions: true,
    downloadGridButton: true,
    gridActionColumn: true,
    selectActionText: 'Select Alert',
    previewActionText: 'View Alert',
    showActionId: true,
    rowSelector: 'AlertID_Rev',
    gridType: 'aml',
    detailViewRoute: '/aml-monitor/',
    showGridColumnFilters: true,
    getSetup: this.getGridSetup,
    getData: this.getGridData,
    storeGridNav: true,
  };
  crumbConfig = [
    {
      label: 'Post Transaction',
      link: 'post-trade/RR',
    },
    {
      label: 'AML Monitor',
      link: 'aml-monitor',
    },
  ];

  ngOnInit(): void {
    this.uas.appsList.set(ptUtilityApps);
    this.rights = this.ss.get('rights');
    this.activatedRoute.params
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(params => {
        if (params.id) {
          this.amlId = params.id;
          this.crumbConfig.push({
            label: 'AML Detail',
            link: `aml-monitor/${this.amlId}`,
          });
        } else {
          this.amlId = '';
        }
      });

    if (this.rights.includes('PostTradeReadOnly')) {
      this.gridConfig.showBulkActions = false;
    }
  }

  ngOnDestroy() {
    this.uas.appsList.set([]);
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  nav(location) {
    this.route.navigate([`/${location}`]);
  }

  getGridSetup() {
    const ssFilters = this.ss.get('AmlMonitorGridFilters');
    const defaultview = {
      filter: [],
      sort: [],
    };

    if (!ssFilters) {
      defaultview.filter.push({
        ProcessedDate: {
          selected: ['30 days'],
        },
      });
    }

    const getHeaders = this.ptSvc.getAmlGridSetup();

    return forkJoin([getHeaders]).pipe(
      map(([data1]) => ({ ...data1, defaultview }))
    );
  }

  getGridData(reqData) {
    return this.ptSvc.getAmlGridData(reqData);
  }
}
